import {
  GET_MESSAGES_FAILURE,
  GET_MESSAGES_SUCCESS,
  MESSAGES_LOADING,
  MESSAGES_MARKED_AS_READ,
} from '../actions/types';

const initialState = {
  messages: [],
  loading: false,
  error: false,
  errorMessage: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_MESSAGES_SUCCESS:
      return {
        ...state,
        messages: action.payload,
        loading: false,
      };
    case MESSAGES_MARKED_AS_READ: {
      const current = state.messages;
      // if messages.messages.contents exists, filter out those with this case_id
      if (
        current &&
        current.messages &&
        Array.isArray(current.messages.contents)
      ) {
        const remaining = current.messages.contents.filter(
          (m) => m.case_id !== action.payload
        );
        return {
          ...state,
          messages: {
            ...current,
            messages: {
              ...current.messages,
              contents: remaining,
              totalPages: current.messages.totalPages,
            },
          },
        };
      }
      return state;
    }
    case GET_MESSAGES_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        errorMessage: action.payload,
      };
    case MESSAGES_LOADING:
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
}
